import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Container, Row, Nav } from "react-bootstrap";
import breadcrumbImage from "../../assets/images/course/cousre.jpg";

const Gallery = () => {
  const [gallerylist, setGallerylist] = useState([]);
  const [baseurl, setBaseurl] = useState("");
  const [status, setstatus] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fooder, setfooder] = useState("");
  const [bgImage, setBgImage] = useState("");
  useEffect(() => {
    fetchGallery();
    footerdata();
     bannerimg();
  }, []);

  const fetchGallery = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/gallery-list`
      );
      setGallerylist(res.data.data || []);
      setBaseurl(res.data.imagePath || "");
      setstatus(res.data.status);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };

  const isPrime = (num) => {
    if (num < 2) return false;
    for (let i = 2; i <= Math.sqrt(num); i++) {
      if (num % i === 0) return false;
    }
    return true;
  };

  const getFilteredItems = () => {
    if (!Array.isArray(gallerylist)) return [];

    if (activeTab === "All") return gallerylist;
    if (activeTab === "Set 1")
      return gallerylist.filter((item) => item.id % 2 !== 0);
    if (activeTab === "Set 2")
      return gallerylist.filter((item) => item.id % 2 === 0);
    if (activeTab === "Set 3")
      return gallerylist.filter((item) => isPrime(item.id));
    return [];

    return gallerylist.filter(
      (item) => item.type?.toLowerCase() === activeTab.toLowerCase()
    );
  };

    const bannerimg = async () => {
            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
              );
        
              const baseUrl = res.data.imagePath;
              const courseImage = res.data.home_setting[0]?.course_image;
        
              // Full image URL
              const fullUrl = baseUrl + courseImage;
        
              setBgImage(fullUrl);
            } catch (error) {
              console.error("Error fetching banner:", error);
            }
          };

  return (
    <section className="course Gallery">
      <div className="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
                 <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Gallery</h1>
        </div>
      </div>
      <Container>
        {/* Tabs */}

        {/* Gallery Items */}
        {fooder.gallerypermission == 1 ? (
          <section className="py-60">
            <Nav
              variant="tabs"
              defaultActiveKey="All"
              className="gallery_tab mb-4 justify-content-center"
            >
              <Nav.Item>
                <Nav.Link eventKey="All" onClick={() => setActiveTab("All")}>
                  All
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="Set 1"
                  onClick={() => setActiveTab("Set 1")}
                >
                  Web
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="Set 2"
                  onClick={() => setActiveTab("Set 2")}
                >
                  App
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="Set 3"
                  onClick={() => setActiveTab("Set 3")}
                >
                  SEO
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Row>
              {getFilteredItems().map((item, index) => (
                <Col
                  xl={3}
                  lg={4}
                  sm={6}
                  key={item.id || index}
                  className="g_c mb-24"
                >
                  {/* <div className="gallery_card">
                    <img
                      src={item.image}
                      alt={item.label}
                      className="br-5 mb-8"
                    />
                    <span className="fm-sec">{item.label}</span>
                  </div> */}
                  <div className="gallery_card">
                    {item?.image ? (
                      <img
                        src={`${baseurl}${item.image}`}
                        alt={item.gallary_name || `Image ${index + 1}`}
                        className="br-5 mb-8"
                        onClick={() => {
                          setSelectedImage(item.image);
                          setShowModal(true);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: "200px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "5px",
                          marginBottom: "8px",
                        }}
                      >
                        <img src={breadcrumbImage} alt="Breadcrumbs" />{" "}
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </section>
        ) : (
          ""
        )}
      </Container>
      {showModal && (
        <div className="gallery-fullscreen" onClick={() => setShowModal(false)}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ position: "relative" }}
          >
            <button
              onClick={() => setShowModal(false)}
              className="image_close_btn"
              aria-label="Close"
            >
              &times;
            </button>

            <img
              src={`${baseurl}${selectedImage}`}
              alt="Enlarged"
              className="galary_show"
            />
          </div>
        </div>
      )}
    </section>
  );
};
export default Gallery;
